/**
 * set Cookie
 * @param name
 * @param value
 * @param daysToLive
 */
window.setCookie = function(name, value, daysToLive) {
  // Encode value in order to escape semicolons, commas, and whitespace
  let cookie = name + '=' + encodeURIComponent(value);

  if (typeof daysToLive === 'number') {
    // Sets the max-age attribute so that the cookie expires after the specified number of days
    cookie += '; max-age=' + (daysToLive * 24 * 60 * 60);

    document.cookie = cookie;
  }
};

/**
 * get Cookie
 * @param name
 * @returns {null|string}
 */
window.getCookie = function(name) {
  // Split cookie string and get all individual name=value pairs in an array
  const cookieArr = document.cookie.split(';');

  // Loop through the array elements
  for (var i = 0; i < cookieArr.length; i++) {
    const cookiePair = cookieArr[i].split('=');

    /* Removing whitespace at the beginning of the cookie name
    and compare it with the given string */
    if (name === cookiePair[0].trim()) {
      // Decode the cookie value and return
      return decodeURIComponent(cookiePair[1]);
    }
  }

  // Return null if not found
  return null;
};

/**
 * check Cookie Notice
 */
window.checkCookieNotice = function() {
  var cookieNotice = window.getCookie('sbrCookieNotice');
  if (cookieNotice === '' || cookieNotice === null) {
    const cookieNoticeHTML = '<div id="cookie_notice" class="cookie-notice">' +
        '<div class="cookie-notice__inner">' +
        '<p class="cookie-notice__text">' + LANG_STRINGS.COOKIE_TEXT + '</p>' + // eslint-disable-line
        '<div class="cookie-notice__btn-wrap">' +
        '<a href="#" id="cookie_notice_button" class="btn btn--big btn--green" onclick="setCookieNotice(); return false;">' + LANG_STRINGS.EINVERSTANDEN + '</a>' + // eslint-disable-line
        '<a href="' + PAGES.privacyCookies + '" target="_blank" id="cookie-more" class="btn btn--big btn--blue">' + LANG_STRINGS.MEHR_ERFAHREN + '</a>' + // eslint-disable-line
        '</div></div></div>';

    // Fügen Sie das HTML am Ende des <body> hinzu
    document.body.insertAdjacentHTML('beforeend', cookieNoticeHTML);
  }
};

/**
 * set Cookie Notice
 */
window.setCookieNotice = function() {
  window.setCookie('sbrCookieNotice', '1', 365);

  const cookieNotice = document.getElementById('cookie_notice');
  if (cookieNotice) {
    cookieNotice.remove();
  }
};
